export default __webpack_public_path__ + "static/Pillars-b9110ff88ab05bc71c5cae6a35de5d6a.png";